import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SwiperModule } from 'swiper/angular';
import { PipesModule } from '../pipes/pipes.module';
import { RglogoComponent } from './lobby/rglogo/rglogo.component';
import { CustomNavbarComponent } from './lobby/custom-navbar/custom-navbar.component';
import { AskCustomerRotateModule } from './ask-customer-rotate/ask-customer-rotate.module';
import { GameModule } from './game/game.module';
import { GamblingProblemComponent } from './gambling-problem/gambling-problem.component';
import { ContactSupportComponent } from './contact-support/contact-support.component';
import { SuccessMessageComponent } from './success-message/success-message.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { NoteBoxComponent } from './note-box/note-box.component';
import { DepositAllMethodsComponent } from './cashier/deposit-all-methods/deposit-all-methods.component';
import { DepositBonusOffersComponent } from './cashier/deposit-bonus-offers/deposit-bonus-offers.component';
import { DepositLimitComponent } from './cashier/deposit-limit/deposit-limit.component';
import { BalanceComponent } from './balance/balance.component';
import { AppInitComponent } from './app-init/app-init.component';
import { ServerNotificationComponent } from './../../app/pages/server-notification/server-notification.component';
import { InactivityComponent } from './../../app/pages/inactivity/inactivity.component';
import { BoydRewardsCardComponent } from './boyd-rewards-card/boyd-rewards-card.component';
import { DepositDefaultAmountsComponent } from './cashier/deposit-default-amounts/deposit-default-amounts.component';
import { LastPlayedGamesModule } from './last-played-games/last-played-games.module';

import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SiteHeaderComponent } from './site-header/site-header.component';
import { WebcontentComponent } from './webcontent/webcontent.component';
import { SiteLogoComponent } from './lobby/site-logo/site-logo.component';
import { FooterModule } from './footer/footer.module';
import { RedirectComponent } from './redirect/redirect.component';
import { SizingComponent } from './mobile/sizing/sizing.component';
import { GameAutomationComponent } from './game-automation/game-automation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationTabsComponent } from './navigation-tabs/navigation-tabs.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { CalendarComponent } from './calendar/calendar.component';
import { BonusSelectorComponent } from './bonus-selector/bonus-selector.component';
import { MobileModule } from './mobile/mobile.module';
import { directivesModule } from '../directives/directives.module';
import { LimitsTableRowComponent } from './limits-table-row/limits-table-row.component';
import { JackpotCounterModule } from './jackpot-notification/jackpot-counter.module';
import { ProgressingComponent } from './progressing/progressing.component';
import { ValidatePinComponent } from './validate-pin/validate-pin.component';
import { DeviceDetailsCollectorService } from '../services/kount/kount.service';
import { SiteFooterComponent } from './site-footer/site-footer.component';
import { FooterBonusRocketComponent } from './footer-bar/footer-bonus-rocket/footer-bonus-rocket.component';
import { FooterLeaderBoardComponent } from './footer-bar/footer-leader-board/footer-leader-board.component';
import { FooterPiggyBankComponent } from './footer-bar/footer-piggy-bank/footer-piggy-bank.component';
import { FooterNextBonusComponent } from './footer-bar/footer-next-bonus/footer-next-bonus.component';
import { FooterBoydRewardComponent } from './footer-bar/footer-boyd-reward/footer-boyd-reward.component';
import { NavbarLevelandAvatarComponent } from './nav-bar/navbar-level-avatar/navbar-level-avatar.component';
import { NavbarShopComponent } from './nav-bar/navbar-shop/navbar-shop.component';
import { CustomCloseComponent } from './buttons/custom-close/custom-close.component';
import { GameTileComponent } from './game-tile/game-tile.component';
import { GameTileLabelComponent } from './game-tile/game-tile-label.component';
import { GameTileMobileComponent } from './game-tile/game-tile-mobile.component';
import { GalleryCasinoComponent } from './gallery-casino/gallery-casino.component';
import { GalleryCasinoMobileComponent } from './gallery-casino/gallery-casino-mobile.component';
import { ShopModule } from './shop/shop.module';
import { CreditCardComponent } from './shop/credit-card/credit-card.component';
import { PurchaseSuccessFailureComponent } from './shop/purchase-success-failure/purchase-success-failure.component';
import { DepositLogoComponent } from './shop/deposit-logo/deposit-logo.component';
import { RocketBonusGameLaunchComponent } from './rocket-bonus-game-launch/rocket-bonus-game-launch.component';
import { LaunchCheckComponent } from './launch-check/launch-check.component';
import { GuestPlayerTocComponent } from './guest-player-toc/guest-player-toc.component';
import { BoydRewardsOptionsComponent } from './boyd-rewards-options/boyd-rewards-options.component';
import { AccountCreatedConfirmationComponent } from './account-created-confirmation/account-created-confirmation.component';
import { ApplyBoydRewardsStepOneComponent } from './apply-boyd-rewards-step-one/apply-boyd-rewards-step-one.component';
import { ApplyBoydRewardsStepTwoComponent } from './apply-boyd-rewards-step-two/apply-boyd-rewards-step-two.component';
import { MigrationSuccessComponent } from './migration-success/migration-success.component';
import { SignupStepOneComponent } from './../pages/signup-step-one/signup-step-one.component';
import { AllPurposeDrawerComponent } from './all-purpose-drawer/all-purpose-drawer.component';
import { StorePurchasesComponent } from './store-purchases/store-purchases.component'
import { AllPurposeDrawerModule } from './all-purpose-drawer/all-purpose-drawer.module';
import { PushNotificationComponent } from './push-notification/push-notification.component'
import { FooterLockLabelComponent } from './footer-bar/footer-lock-label/footer-lock-label.component';
import { PopoverBackgroundComponent } from './popover-background/popover-background.component';
import { OverlayComponent } from './overlay/overlay.component'
import { EnvSelectorComponent } from './env-selector/env-selector.component';
import { LocationSettingsComponent } from './location-settings/location-settings.component';
import { AppRestrictedComponent } from '../pages/app-restricted/app-restricted.component';
import { BoydRewardsLaunchComponent } from './boyd-rewards-launch/boyd-rewards-launch.component';
import { BoydRewardsConnectComponent } from '../pages/boyd-rewards/boyd-rewards-connect/boyd-rewards-connect.component';
import { NotificationComponent} from './notification/notification.component'
import { DateCalendarComponent } from './date-calender/date-calendar.component';
import { GlobalErrorPopoverComponent } from './global-error-popover/global-error-popover.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { BoydRewardsCardOrOnline } from './boyd-rewards-card-or-online/boyd-rewards-card-or-online.component';
import { SocialPlayerTocComponent } from './social-player-toc/social-player-toc.component';
import { CustomBackComponent } from './custom-back/custom-back.component';

@NgModule({
  declarations: [
    AppInitComponent,
    BalanceComponent,
    BonusSelectorComponent,
    BoydRewardsCardComponent,
    CalendarComponent,
    ContactSupportComponent,
    CustomNavbarComponent,
    DateCalendarComponent,
    DateTimePickerComponent,
    DepositAllMethodsComponent,
    DepositBonusOffersComponent,
    DepositDefaultAmountsComponent,
    DepositLimitComponent,
    ErrorMessageComponent,
    FooterBonusRocketComponent,
    FooterLeaderBoardComponent,
    FooterPiggyBankComponent,
    FooterNextBonusComponent,
    FooterBoydRewardComponent,
    GamblingProblemComponent,
    GameAutomationComponent,
    BoydRewardsLaunchComponent,
    AppRestrictedComponent,
    InactivityComponent,
    LimitsTableRowComponent,
    NavbarLevelandAvatarComponent,
    NavbarShopComponent,
    NavigationTabsComponent,
    NoteBoxComponent,
    ProgressingComponent,
    RedirectComponent,
    RglogoComponent,
    ServerNotificationComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    SiteLogoComponent,
    SizingComponent,
    SuccessMessageComponent,
    TransactionListComponent,
    ValidatePinComponent,
    WebcontentComponent,
    CustomCloseComponent,
    GalleryCasinoComponent,
    GalleryCasinoMobileComponent,
    GameTileComponent,
    GameTileMobileComponent,
    LocationSettingsComponent,
    GameTileLabelComponent,
    PurchaseSuccessFailureComponent,
    CreditCardComponent,
    DepositLogoComponent,
    RocketBonusGameLaunchComponent,
    LaunchCheckComponent,
    GuestPlayerTocComponent,
    BoydRewardsOptionsComponent,
    AccountCreatedConfirmationComponent,
    MigrationSuccessComponent,
    BoydRewardsConnectComponent,
    ApplyBoydRewardsStepOneComponent,
    ApplyBoydRewardsStepTwoComponent,
    SignupStepOneComponent,
    StorePurchasesComponent,
    PushNotificationComponent,
    FooterLockLabelComponent,
    PopoverBackgroundComponent,
    PaymentSummaryComponent,
    OverlayComponent,
    NotificationComponent,
    EnvSelectorComponent,
    GlobalErrorPopoverComponent,
    BoydRewardsCardOrOnline,
    SocialPlayerTocComponent,
    CustomBackComponent
  ],
  imports: [
    AllPurposeDrawerModule,
    CommonModule,
    AskCustomerRotateModule,
    GameModule,
    IonicModule,
    JackpotCounterModule,
    SwiperModule,
    PipesModule,
    LastPlayedGamesModule,
    NgxPaginationModule,
    FooterModule,
    FormsModule,
    ReactiveFormsModule,
    MobileModule,
    ShopModule,
    directivesModule,
  ],
  exports: [
    AppInitComponent,
    BalanceComponent,
    BonusSelectorComponent,
    BoydRewardsCardComponent,
    CalendarComponent,
    ContactSupportComponent,
    CustomNavbarComponent,
    DateCalendarComponent,
    DateTimePickerComponent,
    DepositAllMethodsComponent,
    DepositBonusOffersComponent,
    DepositDefaultAmountsComponent,
    DepositLimitComponent,
    ErrorMessageComponent,
    FooterModule,
    FooterBonusRocketComponent,
    FooterLeaderBoardComponent,
    FooterPiggyBankComponent,
    FooterNextBonusComponent,
    FooterBoydRewardComponent,
    GamblingProblemComponent,
    GameAutomationComponent,
    InactivityComponent,
    AppRestrictedComponent,
    LimitsTableRowComponent,
    MobileModule,
    NavbarLevelandAvatarComponent,
    NavbarShopComponent,
    NavigationTabsComponent,
    NoteBoxComponent,
    PipesModule,
    ProgressingComponent,
    RedirectComponent,
    RglogoComponent,
    ServerNotificationComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    SiteLogoComponent,
    SizingComponent,
    SuccessMessageComponent,
    TransactionListComponent,
    ValidatePinComponent,
    WebcontentComponent,
    CustomCloseComponent,
    GalleryCasinoComponent,
    GalleryCasinoMobileComponent,
    GameTileComponent,
    GameTileMobileComponent,
    LocationSettingsComponent,
    GameTileLabelComponent,
    BoydRewardsLaunchComponent,
    ShopModule,
    PurchaseSuccessFailureComponent,
    CreditCardComponent,
    DepositLogoComponent,
    RocketBonusGameLaunchComponent,
    LaunchCheckComponent,
    GuestPlayerTocComponent,
    BoydRewardsOptionsComponent,
    AccountCreatedConfirmationComponent,
    MigrationSuccessComponent,
    BoydRewardsConnectComponent,
    ApplyBoydRewardsStepOneComponent,
    ApplyBoydRewardsStepTwoComponent,
    SignupStepOneComponent,
    StorePurchasesComponent,
    PushNotificationComponent,
    FooterLockLabelComponent,
    PopoverBackgroundComponent,
    PaymentSummaryComponent,
    OverlayComponent,
    NotificationComponent,
    EnvSelectorComponent,
    GlobalErrorPopoverComponent,
    BoydRewardsCardOrOnline,
    SocialPlayerTocComponent,
    CustomBackComponent
  ],
  providers: [
    DeviceDetailsCollectorService,
  ]
})

export class ComponentsModule { }
